"use client";
import clsx from "clsx";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";
import "react-phone-number-input/style.css";
import ReactPhoneNumberInput from "react-phone-number-input";
import fr from "react-phone-number-input/locale/fr.json";

type Props<T extends FieldValues> = {
  id?: string;
  label?: string;
  name: Path<T>;
  control: Control<T>;
  className?: string;
  placeholder?: string;
  inverse?: boolean;
};
export const PhoneInput = <T extends FieldValues>({
  id,
  label,
  name,
  control,
  className,
  placeholder,
  inverse = false,
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div className={clsx("flex flex-col gap-1", className)}>
      {label && (
        <label htmlFor={id} className="text-xs/[14px] pl-2">
          {label}
        </label>
      )}
      <div
        className={clsx(
          "w-full h-12 transition-colors hover:bg-bg-1/50 focus:bg-white focus:border-tx-2 outline-none rounded-lg border px-4 flex items-center",
          {
            "border-no bg-no/[0.02]": error,
            "border-bg-2": !error,
            "bg-bg-1": !error && !inverse,
            "bg-white": !error && inverse,
          },
        )}
      >
        <ReactPhoneNumberInput
          placeholder={placeholder || "Numéro de téléphone"}
          defaultCountry="FR"
          countryOptionsOrder={["FR", "BE", "CH"]}
          labels={fr}
          className="w-full"
          numberInputProps={{
            className:
              "border-none focus:outline-hidden pl-1 text-base/5 font-normal placeholder:text-tx-2 placeholder:font-normal placeholder:text-base/5",
            id,
          }}
          value={field.value}
          onChange={(v) => field.onChange(v || "")}
          onBlur={field.onBlur}
          ref={field.ref}
          disabled={field.disabled}
        />
      </div>
      {error?.message && <p className="text-no text-xs/[14px] pl-2">{error.message}</p>}
    </div>
  );
};
